import {
  SHOW_AUTH_MODAL,
  HIDE_AUTH_MODAL,
  LOGIN,
  SHOW_PASSWORD_RESET_SUCCESS_MODAL,
  HIDE_PASSWORD_RESET_SUCCESS_MODAL,
  HIDE_DEPOSIT_MODAL,
  AppAction,
  TOGGLE_DEPOSIT_SUCCESS_MODAL,
} from '../../actions/app';

export interface State {
  visible?: 'authentication' | 'passwordResetSuccess' | 'depositSuccess';
}

export default function reducer(state: State = {}, action: AppAction): State {
  switch (action.type) {
    case SHOW_AUTH_MODAL:
      return {
        visible: 'authentication',
      };

    case LOGIN:
    case HIDE_AUTH_MODAL:
      return state.visible === 'authentication' ? {} : state;

    case SHOW_PASSWORD_RESET_SUCCESS_MODAL:
      return { visible: 'passwordResetSuccess' };

    case HIDE_PASSWORD_RESET_SUCCESS_MODAL:
      return state.visible === 'passwordResetSuccess' ? {} : state;

    case HIDE_DEPOSIT_MODAL:
      return {};

    case TOGGLE_DEPOSIT_SUCCESS_MODAL:
      return action.payload.visible ? { visible: 'depositSuccess' } : {};

    default:
      return state;
  }
}
